<template>
  <div class="container is-fluid">
    
    <div class="level">
        <div class="level-left">
            <h1 class="title ">Add Funding Details</h1>
        </div>
        <div class="level-right">
            <div class="buttons  is-right">
            <router-link :to="'/applications/' + this.$route.params.id"><button class="button is-info">Back to Application</button></router-link>
        
            </div>
        </div>
    </div>
    <div class="box ">

      <div class="columns">
          <div class="field column">
            <label class="label">Funding Date</label>
            <div class="control ">
             <input v-model="date" type="date" class="input" />
          </div>
        </div>
      </div>	
      
      <div class="columns">
          <div class="field column">
            <label class="label">Governing Body</label>
            <div class="select is-fullwidth ">
              <select  v-model="governingBodyId" required  >
                  <option value="">Select Governing Body ...</option>
                  <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
              </select>
          </div>
        </div>
      </div>

      <div class="columns">
          <div class="field column">
            <label class="label">Funding Type</label>
            <div class="select is-fullwidth ">
              <select  v-model="fundingTypeId" required  >
                  <option value="">Select Funding Type ...</option>
                  <option v-for="row in funding_types" :key="row.id" :value="row.id">{{ row.name }}</option>
              </select>
          </div>
        </div>
      </div>
      
      <div class="columns">
        <div class="field column">
          <label class="label">Amount</label>
          <div class="control">
            <input class="input" type="text" v-model="amount" required>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="field column">
          <label class="label">Comments</label>
          <div class="control">
            <textarea class="textarea" rows="2" v-model="comments" ></textarea>
          </div>
        </div>
      </div>

      <div class="field is-grouped">
        <p class="control">
          <a class="button is-success" @click.prevent="saveApplicationFunding()" :disabled="saving===1">
            Save
          </a>
         
        </p>
       
      </div>


    </div>
	     

  </div>
</template>

<script>


import ApplicationService from '@/services/ApplicationService.js';
import ApplicationMixin from "@/mixins/ApplicationMixin.js";

export default {
  name: 'AddApplicationFunding',
  components: {
   	
  },
  mixins: [ApplicationMixin],
  data() {
    return {
      funding_types: [],
      governing_bodies : [],
       accessToken: '',
       fundingTypeId: '',
       amount:'',
       comments: '',
       date: '',
       application: {governing_body_id: ''},
       saving: 0
     
    }
  },
  computed: {
    governingBodyId: function()
    {
      return this.application.governing_body_id
    }
  },
  // Fetches posts when the component is created.
  created() {
    
     this.getAccessToken()
      .then(() => { 
        this.getApplicationData()
        this.getFundingTypes()
        this.getGoverningBodies()
      });
    
   
  },
  methods: {
  	async saveApplicationFunding() {
        this.saving = 1

         var formdata = { 
          application_id: this.$route.params.id,
          contact_id: this.application.contact_id,
          funding_type_id: this.fundingTypeId,
          amount: this.amount,
          governing_body_id: this.governingBodyId,
          comments: this.comments,
          date: this.date
        }; 


        ApplicationService.saveApplicationFunding(this.accessToken, formdata)
        .then(() => { 
          this.$router.push("/applications/" + this.$route.params.id);
          });
        
      }
    }
    
}

</script>

<style>
	
</style>
